import { createFileRoute } from '@tanstack/react-router';
import { requireTasksFeature } from '@/features/tasks/guard';
import { TrashPage } from '@/features/tasks/trash-page';

export const Route = createFileRoute('/_app/p/$projectKey/settings/trash')({
  beforeLoad: ({ context }) => requireTasksFeature(context.queryClient),
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  return <TrashPage projectKey={projectKey} />;
}
